export enum FilterKeys {
  Project = 'projects',
  Structure = 'structures',
  Section = 'sections',
  PlacementKind = 'placement_kinds',
  Status = 'statuses',
  Stage = 'stages',
  Finishing = 'finishings',
  Options = 'options',
  AbsentOptions = 'absent_options',
  HasApp = 'has_app',
  ReadyForCall = 'readiness',
  StatusCode = 'placement_states',
  Period = 'period',
  Start = 'start',
  End = 'end',
}
